import React from "react";
import { SkeletonComponentProps } from "../../entities/Common";

const SkeletonComponent: React.FC<SkeletonComponentProps> = ({
  children,
  isLoading,
  skeleton,
}: SkeletonComponentProps) => {
  const element = isLoading ? skeleton : children;
  return <>{element}</>;
};

export default SkeletonComponent;
